module.exports = __webpack_public_path__ + "img/under-construction.b33d7ff4.png";